export default __webpack_public_path__ + "static/media/cover.cbe92f91.jpg";